import svgIcons from "../../assets/svg/svgIcons";
import { APP_CONFIG } from "../../constants/constants";
import { useOverviewContext } from "../../pages/overview/context/overview.context";
import { AdminFormFieldCheckbox } from "../admin/formFields";
import DualListboxCheckboxItem from "../dualListboxCheckboxItem";

const AssetsSelector = (props: any) => {
  const {
    allAssetsOptionEnabled,
    data,
    selectAll,
    handleSelectAllChange,
    handleCheckboxChange,
    assetSearchKeyword,
    setAssetSearchKeyword,
    loading,
    allowIndividualSelectionWhenSelectAll = false,
    selectorItemTitleFormatter = (item: any) => item.title || item.id,
  } = props;

  const { setAllAssetsSelected } = useOverviewContext();

  return (
    <div className="relative col-span-6 flex flex-col h-[calc(100vh-480px)] min-h-60 overflow-y-auto">
      {/* loading animation */}
      {loading && (
        <div className="absolute top-0 left-0 w-full h-full bg-white/60 flex items-center justify-center pointer-events-none touch-none z-10">
          <img src={svgIcons.LoadingAnimation} alt="" className="size-12" />
        </div>
      )}

      {/* <div className="absolute w-full h-full overflow-auto grid grid-cols-6 gap-2 content-center pl-2 mt-0"> */}
      <div className="sticky top-0 mb-2 bg-white z-10">
        {/* <div className="flex items-center gap-8">
          <TickCheckbox
            id="all"
            isChecked={selectAll}
            handleChange={handleSelectAllChange}
            disabled={false}
          />
          <label htmlFor="all">Select All</label>
        </div> */}
        {!!allAssetsOptionEnabled && (
          <AdminFormFieldCheckbox
            id="all"
            label="Select All"
            type="checkbox"
            name="all"
            checked={selectAll}
            onChange={handleSelectAllChange}
            // disabled={!allAssetsOptionEnabled || !!assetSearchKeyword || loading}
            key={`all_assets_${selectAll.toString()}`}
            disabled={!!assetSearchKeyword}
          />
        )}
      </div>
      <div className="flex flex-col gap-2">
        {data.map((item: any) => (
          <DualListboxCheckboxItem
            key={`${item.id}_${selectAll?.toString()}_${item.checked?.toString()}`} // added `selectAll` and `item.checked` here to force re-render
            id={item.id.toString()}
            // title={`${item.title || item.id}`}
            title={selectorItemTitleFormatter(item)}
            // sub_title={item.sub_title || "-"}
            handleChange={(e) => {
              // handleCheckboxChange({
              //   item: item,
              //   isChecked: e.target.checked,
              // })
              handleCheckboxChange(item.id);
              if (APP_CONFIG.DEBUG.ALL)
                console.log("item.id", item.id, e.target.checked);
            }}
            // show={groupPage ? (showInactiveEntities ? true : item.isactive === 1) : true}
            show={true}
            // defaultChecked={selectAll}
            defaultChecked={item.checked}
            disabled={
              (selectAll && !allowIndividualSelectionWhenSelectAll) || loading
            }
            // disabled={true}
            uncheckWhenDisabled={false}
          />
        ))}
        {/* <div className="flex items-center gap-8">
          <TickCheckbox
            id={item.id.toString()}
            isChecked={item.checked}
            handleChange={() => handleCheckboxChange(item.id)}
            disabled={false}
          />
          <label htmlFor={item.id.toString()}>{item.label}</label>
        </div> */}
      </div>
    </div>
  );
};

export default AssetsSelector;
